import Axios from '../utils/axios-utils';

// create Incidents
export const createIncidents = async (data, accountId) => {
    try {
        const response = await Axios.post(`/accounts/${accountId}/incidents`, {
            vehicleId: data.vehicleId,
            incidentTime: data.incidentTime,
            type: data.type,
            causedBy: data.causedBy,
            location: data.location,
            note: data.note
        });

        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Create Incidents error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Create Incidents failed" }
        };
    }
};

// update Incident
export const updateIncident = async (accountId, incidentId, data) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/incidents/${incidentId}`, data);
        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update Incident error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update Incident failed" }
        };
    }
};

// delete Incident
export const deleteIncident = async (accountId, incidentId) => {
    try {
        const response = await Axios.delete(`/accounts/${accountId}/incidents/${incidentId}`);
        return {
            success: response.data.status === 'success',
            data: response.data,
            status: response.status
        };
    } catch (error) {
        console.log("Delete Incident error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Delete Incident failed" },
            status: error.response?.status || 500
        };
    }
};

// get all Incidents
export const getAllIncidents = async (accountId, from, to) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/incidents`, {
            params: { from, to },
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Incidents error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Incidents failed" }
        };
    }
};


// update Incidents status
export const updateIncidentStatus = async (accountId, incidentId, status) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/incidents/${incidentId}/status`, {
            status,
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update Incident Status error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update Incident Status failed" }
        };
    }
};

// get  Incident media
export const getIncidentMedia = async (accountId, incidentId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/incidents/${incidentId}/media`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get Incident media error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "GetIncident media failed" }
        };
    }
};

// get all incidents statuses
export const getAllIncidentStatuses = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/incidents/statuses`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Incident statuses error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Incident statuses failed" }
        };
    }
};

// get all incidents types
export const getAllIncidentTypes = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/incidents/types`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Incident types error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Incident types failed" }
        };
    }
};
